<template>
    <v-switch
        class="compact"
        color="primary" 
        :input-value="value[schema.name]" 
        @change="$emit('change', $event)"
        :label="schema.label" 
        :hide-details="true" 
        :hint="schema.hint" 
        :placeholder="schema.placeholder"
        outlined dense 
    />
</template>

<script>



export default {

    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        value: Object,
        schema: Object, 
    },

    computed: {

    },

    methods: {

    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// SwitchControl.vue?78edfda0